import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  contentMinimal: {
    padding: 20,
    maxWidth: 800,
    marginHorizontal: 'auto',
    width: '100%',
  },
  headerContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
    marginBottom: 16,
  },
  headerTitle: {
    fontSize: 22,
    fontWeight: 'bold',
    color: '#1F2024',
  },
  classificacaoText: {
    fontSize: 20,
    fontWeight: '600',
    marginBottom: 20,
    color: '#1F2024',
  },
  stepsContainer: {
    gap: 24,
  },
  stepWrapper: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#f5f5f5',
    borderRadius: 12,
    paddingVertical: 14,
    paddingHorizontal: 18,
    shadowColor: '#000',
    shadowOpacity: 0.05,
    shadowRadius: 8,
    elevation: 2,
    borderWidth: 1,
    borderColor: '#eee',
    transitionDuration: '0.2s',
  },
  stepWrapperDisabled: {
    opacity: 0.5,
  },
  stepLeft: {
    flexDirection: 'row',
    alignItems: 'center',
    position: 'relative',
  },
  stepLine: {
    position: 'absolute',
    left: 12,
    top: 25,
    height: 40,
    width: 2,
    backgroundColor: '#D3D3D3',
  },
  stepCircle: {
    width: 24,
    height: 24,
    borderRadius: 12,
    marginRight: 15,
  },
  stepText: {
    fontSize: 16,
    color: '#1F2024',
    fontWeight: '500',
  },
});
